export default {
  color: "#884AFF",
  autoplay: false,
  muted: false,
  showControlsStart: true,
  showHeroButton: true,
  showVideoTitle: false,
  endVideoAction: "pause",
  showControls: true,
  showButtonFullScreen: true,
  showButtonChapters: true,
  showButtonVolume: true,
  colors: {
    icons: "#884AFF",
    toolbar: "#000000",
    progress: "#884AFF"
  },
  logo: {
    isActive: true,
    data: "",
    href: "https://videas.fr"
  },
  actions: {
    form: {
      isActive: false,
      showNameField: false,
      showSkipButton: true,
      messageText: "Entrez votre email pour lire la vidéo",
      buttonText: "Lecture",
      emailNotification: false
    },
    link: {
      isActive: false,
      href: "https://videas.fr",
      messageText: "Cliquer ici pour découvrir plus de vidéos ! →"
    },
    rating: {
      isActive: false,
      messageText:
        "Merci d'avoir visionner la vidéo ! 😊 \nVous pouvez laisser une note.",
      showCommentField: false
    }
  }
};
